import { Box } from '@mui/material';

export default function BrandLogo({ compact = false, dark = false, sx = {} }) {
  return (
    <Box
      component="img"
      src="/melsoft-logo.jpg"
      alt="Melsoft"
      sx={{
        display: 'block',
        width: compact ? 116 : { xs: 154, sm: 188 },
        height: compact ? 45 : 'auto',
        objectFit: 'contain',
        objectPosition: 'center',
        backgroundColor: '#fff',
        borderRadius: compact ? 1.5 : 2.5,
        px: compact ? 1 : 1.5,
        py: compact ? 0.45 : 0.8,
        boxShadow: dark ? '0 10px 30px rgba(0, 0, 0, 0.28)' : '0 8px 24px rgba(5, 21, 38, 0.12)',
        ...sx
      }}
    />
  );
}
